// src/components/MenuItem.jsx
import React, { useState } from "react";
import { useCart } from "../contexts/CartContext";
import './MenuItem.css'
function MenuItem({ item }) {
  const { addToCart } = useCart();
  const [quantity, setQuantity] = useState(1);

  const handleIncrement = () => setQuantity(quantity + 1);
  const handleDecrement = () => quantity > 1 && setQuantity(quantity - 1);

  const handleAddToCart = () => {
    addToCart({ ...item, quantity });
    setQuantity(1); // Reset quantity after adding
  };

  return (
    <div className="menu-item animate-up">
      <div className="img-container">
        <img src={item.image} alt={item.name} className="item-image" />
      </div>
      <div className="menu-item-content">
        <div className="item-header">
           <h4>{item.name}</h4>
           <span className="price">${item.price.toFixed(2)}</span>
        </div>
        <p className="item-description">A classic choice made with fresh ingredients and our signature recipe.</p> 
        <button onClick={handleAddToCart} className="add-cart">Add to Cart</button>
        
        <div className="quantity-controls">
          <button className="dec-btn" onClick={handleDecrement} disabled={quantity <= 1}>-</button>
          <span className="quan">{quantity}</span>
          <button className="inc-btn" onClick={handleIncrement}>+</button>
        </div>
      </div>
    </div>
  );
}

export default MenuItem;
